import React from 'react'
import DatabaseTest from '../components/test/DatabaseTest'

const DatabaseTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8">Database Test Page</h1>
        <DatabaseTest />
      </div>
    </div>
  )
}

export default DatabaseTestPage